import { VuexModule, getModule, Module, Mutation, Action } from 'vuex-module-decorators';
import { IMenu } from '@/types/menu';
import store from '@/store';
import menuApi from '@/api/menu';
import { addPagePath } from '../../utils';

export interface IRedactState {
  pages: IMenu[];
}

@Module({ dynamic: true, store, name: 'redact' })
class Redact extends VuexModule implements IRedactState {
  public pages: IMenu[] = [];
  loadingPages: boolean = false;

  @Mutation
  private SET_PAGES(pages: IMenu[]) {
    this.pages = pages;
  }
  @Mutation
  private setLoadingPages(loadingPages: boolean) {
    this.loadingPages = loadingPages;
  }

  @Action({ rawError: true })
  public async GetPages() {
    this.setLoadingPages(true);
    try {
      const { data } = await menuApi.getMenuInfo();
      addPagePath(data);
      this.SET_PAGES(data);
    } catch (error) {
      throw error;
    } finally {
      this.setLoadingPages(false);
    }
  }
}

export const RedactModule = getModule(Redact);
